import "./physicianDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import AccordionComponent from "../../../../../shared/components/accordion/accordionComponent";
import {CommonService} from "../../../../../shared/services";
import {Edit} from "@mui/icons-material";
import React, { useEffect, useState} from "react";
import PhysicianDetailsComponent from "../../../../../shared/components/physician-details/PhysicianDetailsComponent";

interface PhysicianDetailsViewComponentProps {
    physicianList?: any;
    onEditModeOpen?: Function;
    facilityId: any;
    onUpdateComplete: Function;
    canEdit: boolean;
}

const PhysicianDetailsViewComponent = (props: PhysicianDetailsViewComponentProps) => {
    const {physicianList, onEditModeOpen,canEdit} = props;

    const [physicianDetailsList, setPhysicianDetailsList] = useState<any[]>([]);


    useEffect(() => {
        if (physicianList?.length > 0) {
            setPhysicianDetailsList(physicianList)
        }
    }, [physicianList]);

    return (
        <div className={'physician-details-view-component'}>
            {!physicianDetailsList?.length ?
                <div className={'physician-details-no-physician-wrapper'}>
                    <div className='no-physician-details-Available-header'>
                        No Provider/Physician have been added to this location.
                    </div>
                    <div className={'physician-details-no-physician-button'}>
                        {canEdit &&
                            <ButtonComponent
                                variant={"outlined"}
                                // className={'width-50'}
                                fullWidth={true}
                                handleClick={onEditModeOpen}
                            >
                                Add Provider/Physician
                            </ButtonComponent>
                        }
                    </div>
                </div> :
                <div
                    className={'d-flex justify-content-space-between align-items-center mrg-bottom-10'}>
                    <div className="form-sub-title mrg-top-15">Added Providers</div>
                    {
                        canEdit &&
                        <ButtonComponent
                            variant={"outlined"}
                            fullWidth={false}
                            type={'button'}
                            color={"primary"}
                            handleClick={onEditModeOpen}
                            startIcon={<Edit/>}
                        >
                            Edit Details
                        </ButtonComponent>
                    }
                </div>
            }
            {physicianDetailsList?.map((physician: any, index: any) => {
                return (
                    <div key={index} className="accordion-layout mrg-bottom-20">
                        <AccordionComponent
                            // disabled={!values.physicianId}
                            isExpanded={physicianDetailsList[index]?.isPhysicianExpand}
                            title={CommonService.physicianWithPrefix(physician)}
                            subTitle={`(NPI: ${physician.npiNumber})`}
                            onChange={(isExpanded) => {
                                if (isExpanded) {
                                    // setCurrentPhysicianIndex(index);
                                }
                                // setFieldValue(`physicianDetails[${index}].isPhysicianExpand`, isExpanded);
                            }}
                        >
                            <div className="physician-details-section">
                                <div className="form-sub-title mrg-top-20">
                                    Personal Details
                                </div>
                                <PhysicianDetailsComponent physician={physician}/>
                            </div>
                        </AccordionComponent>
                    </div>
                )
            })
            }
        </div>
    );

};

export default PhysicianDetailsViewComponent;
